import React from 'react';
import { clientBillingApi } from '@cp/entities/client/current/billing';
import { INFO_MODAL_NAME } from 'src/app/shared/components/modals/info/const';
import { useModal } from 'src/shared/modalProvider';

export const useRemovePaymentCard = () => {
  const { openModal } = useModal();
  const [isLoading, setLoading] = React.useState(false);
  const [deletePaymentCard] = clientBillingApi.endpoints.deletePaymentCard.useMutation();

  return [
    React.useCallback(
      async (...args: Parameters<typeof deletePaymentCard>) => {
        try {
          setLoading(true);

          const isConfirmed = await new Promise((resolve, reject) => {
            openModal(INFO_MODAL_NAME, {
              title: 'Удаление карты',
              message: 'Вы действительно хотите удалить карту?',
              onModalDestroy: reject,
              actions: [
                {
                  title: 'Удалить карту',
                  variant: 'primary',
                  callback: () => resolve(true),
                },
              ],
            });
          });

          if (!isConfirmed) {
            return;
          }

          return await deletePaymentCard(...args);
        } finally {
          setLoading(false);
        }
      },
      [deletePaymentCard, openModal],
    ),
    { isLoading },
  ] as const;
};
